export const serviceTypeNames = {
  0: 'Visit Center',
  1: 'Mobile Service',
  2: 'Pick Up Drop Off',
  3: 'General',
};
